import initialState from 'redux/initialState';
import types from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import { Note, Partner } from 'types';

type NoteAction = {
  type: string;
  notes?: Partner[];
  note?: Partner;
};
const resetStateSociety = () => initialState.notes;

const createNote = (notes: Note[], action: NoteAction) => [
  ...notes,
  action.note,
];

const getNotes = (action: NoteAction) => action.notes;

export default function reducer(
  notes = initialState.notes,
  action: NoteAction
) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case types.CREATE_NOTE:
      return createNote(notes, action);

    case types.GET_NOTES:
      return getNotes(action);

    default:
      return notes;
  }
}
